let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fu2z5")).then(() => parcelRequire('gIBMG'));